// 统一存放表单数据请求

// 入库来源字段信息
export const exportStockSource = (params) => {
  return window._this.$http.post(`/erp/Common/selectStockSource`, params);
};

// 代采组字段信息
export const exportPurchaseGroup = (params) => {
  return window._this.$http.post(`/erp/Common/selectPg`, params);
};



// WEBPACK FOOTER //
// ./src/api/formData.js